import type { SxProps, Theme } from '@mui/material/styles';

/** Вторичная кнопка действий над отчетом (Выбор колонок, Касса, Банк): светлая, с тонкой рамкой */
export const ACTION_BUTTON_SX: SxProps<Theme> = {
  borderColor: '#cbd5e1',
  color: '#475569',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  whiteSpace: 'nowrap',
  '&:hover': { borderColor: '#94a3b8', backgroundColor: '#f8fafc' }
};

/** Основная кнопка выгрузки в Excel (зеленая, без тени) */
export const EXCEL_BUTTON_SX: SxProps<Theme> = {
  backgroundColor: '#10b981',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { backgroundColor: '#059669', boxShadow: 'none' }
};
